@if (cancelConfirmState) {
    <div
        class="flex flex-col justify-between items-center border-2 border-blurple rounded-lg bg-white p-1 z-20"
        [ngStyle]="{
            'height.px': tileHeight,
            'width.px': width,
        }">
        <p-button
            (click)="onClickConfirmCancelSession()"
            severity="warn"
            label="Cancel"
            styleClass="w-full"
            class="w-full" />
        <p-button
            (click)="onClickKeepSession()"
            label="Keep"
            severity="info"
            styleClass="w-full"
            class="w-full" />
    </div>
} @else {
    <div
        class="flex flex-col justify-between items-center rounded-lg absolute bg-latte p-1 relative overflow-hidden z-30"
        [ngStyle]="{
            'height.px': tileHeight,
            'width.px': width,
        }">
        <div class="h-full min-w-1 bg-blurple absolute top-0 left-0"></div>

        <fm-session-indicator-icons
            [isQuietMode]="sessionInfo.preferences.quietMode.value && tileSize != 'xsmall'"
            [activityType]="sessionInfo.activityType"
            [showActivityType]="tileSize == 'large' || tileSize == 'xlarge'"
            [isLockedIn]="isLockedIn"
            class="absolute right-2 top-0" />

        <div class="flex justify-start items-start w-full ml-1 max-w-full pr-2">
            @if (tileSize == 'xlarge') {
                <fm-avatar
                    [fmSendProfileToDynamicPanel]="sessionInfo.partnerProfileUrl"
                    [fmSendProfileToDynamicPanelSource]="'Booked Session: Partner Image'"
                    size="sm"
                    [isSaved]="sessionInfo.saved"
                    [isQuietMode]="sessionInfo.partnerPreferences.quietMode.value"
                    [avatarLocation]="sessionInfo.partnerPhoto" />
            }
            <div
                class="h-full flex flex-col justify-between items-start ml-1 mt-0.5 max-w-full flex-grow w-[calc(100%_-_50px)]">
                <div
                    class="text-12-16 leadning-normal text-bluegrey font-medium text-left font-inter"
                    >{{
                        this.sessionInfo.sessionTime
                            | epochToTime
                                : displayTimeFormat
                                : this.timezone
                                : tileSize == 'small' || tileSize == 'xsmall'
                    }}
                </div>
                <div
                    [fmSendProfileToDynamicPanel]="sessionInfo.partnerProfileUrl"
                    [fmSendProfileToDynamicPanelSource]="'Booked Session: Partner Name'"
                    class="text-12-16 leadning-normal text-bluegrey font-medium text-left font-inter truncate whitespace-nowrap overflow-hidden text-ellipsis max-w-full"
                    >{{ partnerNameOrStatusString }}</div
                >
            </div>
        </div>
        <div class="flex flex-row justify-end items-center w-full gap-1">
            @if (joinButtonAvailable) {
                <a
                    pButton
                    [routerLink]="'/session/' + (sessionInfo.sessionTime / 1000).toString()"
                    class="h-6 no-underline !text-12 ml-1 mr-auto flex-1 !rounded max-w-[120px]"
                    label="Join"></a>
            }
            <p-button
                severity="secondary"
                (click)="onClickSendSessionInfoToDynamicPanel()"
                size="small"
                styleClass="!w-[24px] xs aspect-square !rounded"
                icon="pi pi-ellipsis-h" />
            @if (tileSize == 'large' || tileSize == 'xlarge') {
                <p-button
                    severity="secondary"
                    size="small"
                    styleClass="!w-[24px] xs aspect-square !rounded"
                    (click)="onClickCancelSession()"
                    icon="pi pi-times" />
            }
        </div>
    </div>
}
